/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { LegalFormProvider } from './';
import {
    LegalFormProviderFromJSON,
    LegalFormProviderFromJSONTyped,
    LegalFormProviderToJSON,
} from './';

/**
 * 
 * @export
 * @interface ExternalProviderLegalForms
 */
export interface ExternalProviderLegalForms {
    /**
     * 
     * @type {LegalFormProvider}
     * @memberof ExternalProviderLegalForms
     */
    provider: LegalFormProvider;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExternalProviderLegalForms
     */
    legalForms: Array<string>;
}

/**
 * Check if a given object implements the ExternalProviderLegalForms interface.
 */
export function instanceOfExternalProviderLegalForms(value: object): value is ExternalProviderLegalForms {
    if (!('provider' in value) || value['provider'] === undefined) return false;
    if (!('legalForms' in value) || value['legalForms'] === undefined) return false;
    return true;
}

export function ExternalProviderLegalFormsFromJSON(json: any): ExternalProviderLegalForms {
    return ExternalProviderLegalFormsFromJSONTyped(json, false);
}

export function ExternalProviderLegalFormsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalProviderLegalForms {
    if (json == null) {
        return json;
    }
    return {
        
        'provider': LegalFormProviderFromJSON(json['provider']),
        'legalForms': json['legalForms'],
    };
}

export function ExternalProviderLegalFormsToJSON(value?: ExternalProviderLegalForms | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'provider': LegalFormProviderToJSON(value['provider']),
        'legalForms': value['legalForms'],
    };
}

